export default __webpack_public_path__ + "static/media/ic-art-man-target.c5d44d4d.svg";